export default __webpack_public_path__ + "static/media/tsvc.d6b54cdc.png";